import { request } from './index'

const getUrlParam = (name: string) => {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return ''
}

const token = getUrlParam('k')?.toString()

interface OrderParams {
  orderNo: string
}
const getPayOrder = async (params: OrderParams) => {
  const res = await request({
    method: 'get',
    data: params,
    url: `/api/payorder?orderNo=${params.orderNo}`,
    headers: {}
  })
  return res.data as any
}

// ====================== Commerce ======================
const getPayIn = async () => {
  const res = await request({
    method: 'get',
    url: `/api/commerce/payin`,
    headers: {
      'klicklpay-token': token
    }
  })
  return res.data as any
}

interface PostCryptoPayInParam {
  currency: string
  payment_type: string
}
const postCryptoPayIn = async (data: PostCryptoPayInParam) => {
  const res = await request({
    method: 'post',
    data,
    url: `/api/commerce/crypto/payin`,
    headers: {
      'klicklpay-token': token
    }
  })
  return res.data as any
}

interface TopUpRequiredFieldsParam {
  currency: string
  payment_type: string
}
const getTopUpRequiredFields = async (params: TopUpRequiredFieldsParam) => {
  const res = await request({
    method: 'get',
    params,
    url: `/api/commerce/cash/TopUpRequiredFields`,
    headers: {
      'klicklpay-token': token
    }
  })
  return res.data as any
}

interface PostFiatPayInParam {
  currency: string
  payment_type: string
  [key: string]: any
}
const postFiatPayIn = async (data: PostFiatPayInParam) => {
  const res = await request({
    method: 'post',
    data,
    url: `/api/commerce/cash/payin`,
    headers: {
      'klicklpay-token': token
    }
  })
  return res.data as any
}

const cancelOrder = async (orderNo: string) => {
  const res = await request({
    method: 'post',
    url: `api/commerce/crypto/payin/${orderNo}/Cancel`,
    headers: {
      'klicklpay-token': token
    }
  })
  return res.data as any
}

export default {
  getPayOrder,
  getPayIn,
  postCryptoPayIn,
  getTopUpRequiredFields,
  postFiatPayIn,
  cancelOrder
}